import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIS } from 'src/app/apis';
import { MoovInstanceData } from '../challenge/challenges-data';
import { AbstractConflictsService } from './conflict.abstract.service';
import { ConflictData, ConflictMoovData } from './conflicts-data';

@Injectable({
  providedIn: 'root'
})
export class ConflictsService implements AbstractConflictsService {
  private getConflictsForUsersUrl = `${APIS.conflicts}/getConflictsForUsers`;
  private getConflictMoovsUrl = `${APIS.conflicts}/getConflictMoovs`;
  private activateConflictMoovUrl = `${APIS.conflicts}/activateConflictMoov`;
  private getConflictsMoovsForUsersUrl = `${APIS.conflicts}/getConflictsMoovsForUsers`;

  constructor(private http: HttpClient) { 
  }

  getConflictsForUsers (teamMemberId: string, counterpartId: string): Observable<ConflictData[]> {
    // console.log('trying to fetch conflicts for users');
    return this.http.get<ConflictData[]>(`${this.getConflictsForUsersUrl}?userId=${teamMemberId}&counterpartId=${counterpartId}`);
  }

  getConflictMoovs (conflictId: string): Observable<ConflictMoovData[]> {
    // console.log(`trying to fetch moovs for conflict ${conflictId}`);
    return this.http.get<ConflictMoovData[]>(`${this.getConflictMoovsUrl}?conflictId=${conflictId}`);
  }

  getConflictsMoovsForUsers (teamMemberId: string, counterpartId: string): Observable<ConflictMoovData[]> {
    // console.log(`trying to fetch moovs for users`);
    return this.http.get<ConflictMoovData[]>(`${this.getConflictsMoovsForUsersUrl}?teamMemberId=${teamMemberId}&counterpartId=${counterpartId}`);
  }

  activateConflictMoov (moovId: string, firstCounterpartId: string, secondCounterpartId: string): Observable<MoovInstanceData> {
    console.log(`trying to activate moov for conflict`);
    console.log (`${this.activateConflictMoovUrl}?moovId=${moovId}&firstCounterpartId=${firstCounterpartId}&secondCounterpartId=${secondCounterpartId}`);
    return this.http.get<MoovInstanceData>(`${this.activateConflictMoovUrl}?moovId=${moovId}&firstCounterpartId=${firstCounterpartId}&secondCounterpartId=${secondCounterpartId}`);
  }
}
